<template>
    <AffiliateLandingPage imageExt="png" imageName="Access" routePath="accessdevelopment" company="Access"></AffiliateLandingPage>
</template>
  
<script>
import AffiliateLandingPage from '@/components/Affiliate/AffiliateLandingPage.vue'

export default {
    components: {
        AffiliateLandingPage
    },
    name: 'AccessDevelopmentLandingPage'
}
</script>
  
<style></style>
  